import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Table, Nav, Row, Col } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { toast } from "react-toastify";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Select from "react-select";

const ReferralSetting = ({ activeTab, setActiveTab }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [statusOption, setStatusOption] = useState([
        { value: 1, label: "Active" },
        { value: 0, label: "In-Active" },
    ]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {

            setLoading(true);
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getReferralSetting",
                user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;

            if (output) {
                setRows(output);
            }
       
    };

    const { handleSubmit, values, errors, touched, handleChange, handleBlur, setTouched, resetForm, setFieldValue } = useFormik({
        initialValues: {
            pk_rese_key: "",
            amount: "",
            description: "",
            status: "",
        },
        validationSchema: Yup.object().shape({
            amount: Yup.string()
                .required("Amount is required."),
            description: Yup.string()
                .required("Description is required."),
            status: Yup.string()
                .required("Status is required."),
        }),
        onSubmit: async (formValues) => {
            toast.dismiss();
            setIsSubmitting(true);

            try {
                const response = await axios.post(
                    `${BASE_URL}API/apicall`,
                    {
                        security_key,
                        mode: activeTab == "referral-add" ? "addReferralSetting" : "updateReferralSetting",
                        ...formValues,
                        // user_key: sessionStorage.getItem("pk_user_key"),
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output == 1) {
                    if (activeTab == "referral-add") {
                        
                        toast.success("Added successfully!", {
                            autoClose: 3000,
                        });
                    } else {
                        toast.success("Updated successfully!", {
                            autoClose: 3000,
                        });
                    }
                    setActiveTab("referral-list");
                    fetchData();
                } else {
                    toast.error("Oops! Something went wrong.", {
                        autoClose: 3000,
                    });
                }
            } catch (error) {
                toast.error("Error: " + error.message);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    const handleEditClick = (selRow) => {
        setFieldValue("pk_rese_key", selRow.pk_rese_key);
        setFieldValue("amount", selRow.amount);
        setFieldValue("description", selRow.description);
        setFieldValue("status", selRow.status);
        setActiveTab("referral-edit");
    };

    const handleCancel = () => {
        resetForm("");
        setActiveTab("referral-list");
    };


    return (
        <>
            {activeTab === "referral-list" && (
                <div>
                    {rows.length == 0 && (
                        <div className="text-end my-1">
                            <button className="btn btn-sm btn-dark" onClick={() => setActiveTab("paypal-add")}>
                                Add
                            </button>
                        </div>
                    )}
                    <div className="table-responsive">
                        <Table striped bordered hover className="table-responsive-scroll">
                            <thead className="thead-dark">
                                <tr>
                                    <th>S.No</th>
                                    <th>Amount</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.length == 0 && (
                                    <tr>
                                        <td colSpan={3}>
                                            <h6 className="text-center">No data available</h6>
                                        </td>
                                    </tr>
                                )}
                                {rows.map((row, index) => (
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>${row.amount}</td>
                                        <td>{row.description}</td>
                                        <td>{row.status === 1 ? 'Active' : 'In-Active'}</td>
                                        <td>
                                            <Tooltip title="Edit">
                                                <Button variant="outline-dark" size="sm" onClick={() => handleEditClick(row)} className="me-2">
                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                </Button>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )}

            {activeTab === "referral-add" && (
                <div className="bg-white p-4">
                    <h4>Add Referral Details</h4>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Amount <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="amount"
                                value={values.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter amount"
                            />
                            {errors.amount && touched.amount && <p className="text-danger">{errors.amount}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter description"
                            />
                            {errors.description && touched.description && <p className="text-danger">{errors.description}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Status <span className="text-danger">*</span>
                            </Form.Label>
                            <Select
                                options={statusOption}
                                id="status"
                                name="status"
                                value={statusOption.find((option) => option.value && values.status && option.value.toString() === values.status.toString())}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "status",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, status: true });
                                }}
                            />

                            {errors.status && touched.status && <p className="text-danger">{errors.status}</p>}
                        </Form.Group>

                        <Button type="submit" className="btn btn-dark mt-3" disabled={isSubmitting}>
                            Add
                            {isSubmitting && <LinearProgress />}
                        </Button>
                        <Button type="button" className="btn btn-outline-secondary ms-2 mt-3" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                </div>
            )}

            {activeTab === "referral-edit" && (
                <div className="bg-white p-4">
                    <h4>Edit Referral Details</h4>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Amount <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="amount"
                                value={values.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter amount"
                            />
                            {errors.amount && touched.amount && <p className="text-danger">{errors.amount}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter description"
                            />
                            {errors.description && touched.description && <p className="text-danger">{errors.description}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Status <span className="text-danger">*</span>
                            </Form.Label>
                            <Select
                                options={statusOption}
                                id="status"
                                name="status"
                                value={statusOption.find((option) => option.value === parseInt(values.status))} // Ensure proper comparison
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "status",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, status: true });
                                }}
                            />


                            {errors.status && touched.status && <p className="text-danger">{errors.status}</p>}
                        </Form.Group>

                        <Button type="submit" className="btn btn-dark mt-3" disabled={isSubmitting}>
                            Save
                            {isSubmitting && <LinearProgress />}
                        </Button>
                        <Button type="button" className="btn btn-outline-secondary ms-2 mt-3" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                </div>
            )}
        </>
    );
};

export default ReferralSetting;
